<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
    >
      <template #top>
        <v-text-field v-model="search" label="Suche">
          <v-icon slot="append">
            mdi-magnify
          </v-icon>
        </v-text-field>
      </template>
      <template #[`item.actions`]="{ item }">
        <Inertia-Link :href="route('item.edit', item.id)">
          <v-icon small>
            mdi-pencil
          </v-icon>
        </Inertia-Link>

        <v-icon @click="deletePrompt(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title class="text-h5">
          Sind Sie sicher dass dieses Item entfernt werden soll?
        </v-card-title>

        <v-card-text>
          Item: {{ selectedItem.itemName }} Produkt:
          {{ selectedItem.productName }}
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn color="green darken-1" text @click="dialog = false">
            Disagree
          </v-btn>

          <v-btn color="red darken-1" text @click="softDelete()">
            Agree
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Admin'
export default {
   name: 'ItemIndex',
   metaInfo () {
      return {
         title: this.title ? this.title : 'Verkaufsartikel Übersicht',
      }
   },
   layout: (h, page) => h(Layout, [page]),

   props: {
      items: {
         type: Array,
         required: true,
      },
   },
   data () {
      return {
         headers: [
            { text: 'Produkt-Typ', value: 'productType' },
            { text: 'Produkt-Name', value: 'productName' },
            { text: 'Artikel-Name', value: 'itemName' },
            { text: 'Aktionen', value: 'actions', sortable: false },
         ],
         dialog: false,
         selectedItem: {
            itemName: '',
            productName: '',
            productType: '',
            id: null,
         },
         search: null,
      }
   },
   methods: {
      deletePrompt (item) {
         this.selectedItem = item
         this.dialog = true
      },
      softDelete () {
         this.$inertia
            .patch(this.route('item.soft_destroy', this.selectedItem.id))
            .then((response) => (this.dialog = false))
      },
      // edit()
   },
}
</script>

<style></style>
